<script>
import store from '@state/store'
import Layout from '@layouts/loggedin.vue'
import UserHeader from '@users/components/user-header.vue'
import { authComputed } from '@state/helpers'
import Tab from '@router/components/tab.vue'
import Tabs from '@router/components/tabs.vue'
import EventTile from '@events/components/event-tile.vue'
import PostFeed from '@router/components/post-feed.vue'
import { POSTS_PER_PAGE } from '@/src/router/constant'

export default {
  components: {
    Layout,
    UserHeader,
    Tab,
    Tabs,
    EventTile,
    PostFeed,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    postsCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      filterStatusUpdates: false,
      loadingMore: false,
      noMorePosts: false,
      activeTab: 1,
    }
  },
  computed: {
    ...authComputed,
  },
  methods: {
    statusUpdates() {
      var statusUpdates = this.$store.state.users.statusUpdates || []
      if (this.filterStatusUpdates) {
        statusUpdates = statusUpdates.filter(
          (statusUpdate) => statusUpdate.type === this.filterStatusUpdates
        )
      }

      return statusUpdates
    },
    toggleOverlay(params) {
      this.showOverlay = params.showHide
    },
    fetchMoreStatusUpdates() {
      if (this.activeTab === 1 || this.postsCount < POSTS_PER_PAGE)
        return (this.noMorePosts = true)

      this.loadingMore = true
      store
        .dispatch('users/fetchStatusUpdates', {
          userId: this.user.id,
        })
        .then((posts) => {
          this.loadingMore = false
          this.noMorePosts = !posts.length
        })
        .catch(() => {})
    },
    changedTab(params) {
      this.activeTab = params.index
    },
  },
}
</script>

<template>
  <Layout>
    <UserHeader :user="user"></UserHeader>
    <div class="w-content h-auto flex bg-blue-lightest  ">
      <Tabs
        :classes="'flex justify-between'"
        :parent-classes="'w-content bg-white flex justify-center'"
        :tab-classes="
          'border-b-5 pb-5 text-xl mx-8 leading-loose cursor-pointer'
        "
        @changed-tab="changedTab"
      >
        <Tab
          title='<svg id="Group_254" data-name="Group 254" xmlns="http://www.w3.org/2000/svg" width="29.422" height="25.443" viewBox="0 0 29.422 25.443" class="inline-block align-middle mr-2"><path id="Path_113" data-name="Path 113" d="M35.848,14.5H15.673a2.493,2.493,0,0,0-2.508,2.508v1.075H11.408A2.493,2.493,0,0,0,8.9,20.592V37a2.92,2.92,0,0,0,2.759,2.938H35.382A2.952,2.952,0,0,0,38.321,37v-20A2.463,2.463,0,0,0,35.848,14.5ZM13.164,37.112a1.3,1.3,0,0,1-.43,1,1.561,1.561,0,0,1-1.039.394A1.466,1.466,0,0,1,10.333,37V20.592a1.056,1.056,0,0,1,1.075-1.075h1.756ZM36.923,37a1.514,1.514,0,0,1-1.505,1.505H14.239a5.076,5.076,0,0,0,.287-.645v-.072c.036-.072.036-.179.072-.287v-.072c0-.108.036-.215.036-.358V17.008a1.056,1.056,0,0,1,1.075-1.075H35.848a1.056,1.056,0,0,1,1.075,1.075Z" transform="translate(-8.9 -14.5)" fill="#069bd7"/><path id="Path_114" data-name="Path 114" d="M65.269,36.1H58.317a.717.717,0,0,0,0,1.433h6.952a.717.717,0,1,0,0-1.433Z" transform="translate(-40.148 -28.36)" fill="#069bd7"/><path id="Path_115" data-name="Path 115" d="M65.269,47.6H58.317a.717.717,0,0,0,0,1.433h6.952a.717.717,0,1,0,0-1.433Z" transform="translate(-40.148 -35.739)" fill="#069bd7"/><path id="Path_116" data-name="Path 116" d="M48.137,59.1H31.617a.717.717,0,1,0,0,1.433h16.52a.717.717,0,0,0,0-1.433Z" transform="translate(-23.016 -43.117)" fill="#069bd7"/><path id="Path_117" data-name="Path 117" d="M65.269,24.5H58.317a.717.717,0,0,0,0,1.433h6.952a.717.717,0,1,0,0-1.433Z" transform="translate(-40.148 -20.916)" fill="#069bd7"/><path id="Path_118" data-name="Path 118" d="M48.137,70.7H31.617a.717.717,0,1,0,0,1.433h16.52a.717.717,0,0,0,0-1.433Z" transform="translate(-23.016 -50.561)" fill="#069bd7"/><path id="Path_119" data-name="Path 119" d="M31.617,34.211h6.307a.719.719,0,0,0,.717-.717V25.217a.719.719,0,0,0-.717-.717H31.617a.719.719,0,0,0-.717.717v8.278A.719.719,0,0,0,31.617,34.211Zm.717-8.278h4.874v6.845H32.333Z" transform="translate(-23.016 -20.916)" fill="#069bd7"/></svg><span class="align-middle">News Feed</span>'
        >
          <div class="h-auto flex mt-16 pl-15 pr-15 justify-center w-content">
            <div
              class="left-posts w-7/12 bg-white rounded-xl shadow-box relative"
            >
              <div class="absolute top-0" style="right:-10.25rem;">
                <div class="text-blue-darker text-basel">Filter By:</div>
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = false"
                  >All</button
                >
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = 'gratitude'"
                  >Gratitude</button
                >
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = 'volunteered'"
                  >Volunteer Hours</button
                >
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = 'kyndness'"
                  >PENCIL Positives</button
                >
                <button
                  class="text-blue text-lg block"
                  @click="filterStatusUpdates = 'donation'"
                  >Donation</button
                >
              </div>
              <PostFeed
                :status-updates="statusUpdates()"
                :loading-more="loadingMore"
                :no-more-posts="noMorePosts"
                @fetch-more-status-updates="fetchMoreStatusUpdates"
              ></PostFeed>
            </div>
          </div>
        </Tab>
        <Tab
          v-if="user.id === currentUserId"
          title='<svg xmlns="http://www.w3.org/2000/svg" width="27.499" height="26.31" viewBox="0 0 27.499 26.31" class="inline-block align-middle mr-2"><path id="Path_120" data-name="Path 120" d="M35.824,22.983H30.556V20.092a.675.675,0,0,0-1.35,0v2.891H16.293V20.092a.675.675,0,0,0-1.35,0v2.891H9.675A.676.676,0,0,0,9,23.658V45.052a.676.676,0,0,0,.675.675H35.824a.676.676,0,0,0,.675-.675V23.658A.676.676,0,0,0,35.824,22.983Zm-.675,21.394H10.35V31.464h24.8Zm0-14.263H10.35V24.333h4.593v1.7a.675.675,0,0,0,1.35,0v-1.7H29.206v1.7a.675.675,0,0,0,1.35,0v-1.7h4.593Z" transform="translate(-9 -19.417)" fill="#00638a"/></svg><span class="align-middle">Volunteer Opportunities</span>'
        >
          <div class="h-auto mt-17 my-7.7 w=content">
            <div class="flex events-grid">
              <div
                v-for="oneEvent in user.opportunities"
                :key="oneEvent.id"
                class="event-box-wrapper"
              >
                <EventTile
                  :one-event="oneEvent"
                  @open-modal="openEventModal(oneEvent)"
                ></EventTile>
              </div>
            </div>
          </div>
        </Tab>
        <Tab
          title='<svg xmlns="http://www.w3.org/2000/svg" width="40.206" height="41.785" viewBox="0 0 40.206 41.785" class="inline-block align-middle mr-2"><g id="Group_256" data-name="Group 256" transform="translate(0 0)"><path id="Path_121" data-name="Path 121" d="M180.328,36.721l-.252-.575,3.283-1.016L181.145,32.5,184,30.6l-2.86-1.9,2.215-2.628-3.283-1.016,1.379-3.147-3.435-.048.439-3.407-3.311.917-.537-3.394-2.919,1.815-1.476-3.1-2.286,2.564-2.286-2.564-1.476,3.1-2.918-1.815-.537,3.394-3.309-.917.438,3.407-3.435.047,1.379,3.148L152.5,26.069l2.214,2.629-2.859,1.9,2.859,1.9L152.5,35.129l3.283,1.016-.1.237-.253-.193-7.857,10.286h8.414v10l8.871-11.614.787,1.656,2.287-2.564,2.286,2.564.591-1.243,8.556,11.2v-10h8.414ZM164.086,43.48l-6.651,8.707V45.026H150.5l4.375-5.727,2.966.042-.439,3.406,3.31-.916.536,3.394,2.919-1.815.1.209Zm3.845-1.434-1.963,2.2-1.266-2.66-2.5,1.555-.46-2.91-2.84.786.376-2.923-2.947-.041,1.182-2.7-2.813-.871,1.9-2.253L154.144,30.6l2.455-1.632-1.9-2.253,2.814-.871-1.182-2.7,2.947-.041L158.9,20.18l2.84.786.46-2.909,2.5,1.555,1.266-2.66,1.962,2.2,1.961-2.2,1.266,2.66,2.5-1.555.46,2.91,2.84-.786-.376,2.923,2.947.041-1.182,2.7,2.813.87-1.9,2.253,2.455,1.632-2.455,1.632,1.9,2.253-2.813.871.669,1.526-.245.187.752.985-2.94.041.376,2.923-2.84-.786-.46,2.909-2.5-1.555-1.266,2.66Zm9.983,2.98v7.161L171.508,43.8l.185-.388,2.918,1.815.537-3.394,3.31.917-.439-3.407,2.461-.034,4.369,5.719Z" transform="translate(-147.572 -14.686)" fill="#069BD7"/><path id="Path_122" data-name="Path 122" d="M184,33.934a10.158,10.158,0,1,0-10.158,10.158A10.169,10.169,0,0,0,184,33.934Zm-10.158,8.71a8.71,8.71,0,1,1,8.708-8.71A8.719,8.719,0,0,1,173.842,42.644Z" transform="translate(-153.482 -18.021)" fill="#069BD7"/></g></svg> <span class="align-middle">Badges</span>'
        >
          <div class="h-auto flex mt-16 pl-15 pr-15 justify-center w-content">
            <div
              class="left-posts w-8/12 bg-white rounded-xl shadow-box relative px-12 py-12"
            >
              <div class="flex justify-start mb-10 flex-wrap">
                <div
                  v-if="user.badges_filtered['Gratitude']"
                  class="text-center px-8 py-4"
                >
                  <div class="text-blue-darker text-2xl">
                    Gratitude
                  </div>
                  <div class="text-gray text-base mb-4">
                    {{ user.badges_filtered['Gratitude'].value }} Posts
                  </div>
                  <div class="relative text-center">
                    <span
                      class="inline-block absolute text-white text-7xl text-center left-0 right-0 mx-auto mt-5"
                      >{{ user.badges_filtered['Gratitude'].value }}</span
                    >
                    <svg
                      id="Component_1_1"
                      data-name="Component 1 – 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="171.96"
                      height="171.96"
                      viewBox="0 0 171.96 171.96"
                    >
                      <g id="Group_290" data-name="Group 290">
                        <ellipse
                          id="Ellipse_85"
                          data-name="Ellipse 85"
                          cx="85.98"
                          cy="85.98"
                          rx="85.98"
                          ry="85.98"
                          fill="#924cd8"
                        />
                      </g>
                      <g
                        id="Group_294"
                        data-name="Group 294"
                        transform="translate(8.009 17.374)"
                      >
                        <g
                          id="Group_292"
                          data-name="Group 292"
                          transform="translate(110.552)"
                        >
                          <path
                            id="Path_141"
                            data-name="Path 141"
                            d="M4167,692.777a71.941,71.941,0,0,1,17.887,11.1,77.058,77.058,0,0,1,7.607,7.413q.876,1,1.739,2.017l1.662,2.083,1.592,2.14c.513.726,1.01,1.464,1.513,2.2a75.184,75.184,0,0,1,9.146,19.267,76.121,76.121,0,0,1,2.442,10.43,77.323,77.323,0,0,1,.422,21.373,76.7,76.7,0,0,1-2.027,10.518,75.162,75.162,0,0,1-8.378,19.613l-.693,1.14-.731,1.116-.735,1.113-.771,1.088-.773,1.085-.806,1.061c-.271.352-.532.711-.812,1.055l-.846,1.029a77.336,77.336,0,0,1-7.308,7.707,72.007,72.007,0,0,1-17.434,11.8,81.152,81.152,0,0,0,28.579-29.552,77.553,77.553,0,0,0,7.556-19.068,78,78,0,0,0-.793-40.568,77.575,77.575,0,0,0-8.3-18.758A80.992,80.992,0,0,0,4167,692.777Z"
                            transform="translate(-4167 -692.777)"
                            fill="#fff"
                          />
                        </g>
                        <g id="Group_293" data-name="Group 293">
                          <path
                            id="Path_142"
                            data-name="Path 142"
                            d="M3760.615,692.777a81,81,0,0,0-29.732,28.4,77.574,77.574,0,0,0-8.3,18.758,78.061,78.061,0,0,0-.794,40.568,77.573,77.573,0,0,0,7.557,19.068,81.148,81.148,0,0,0,28.579,29.552,72.019,72.019,0,0,1-17.435-11.8,77.4,77.4,0,0,1-7.309-7.707l-.845-1.029c-.281-.344-.542-.7-.812-1.055l-.806-1.061-.773-1.085-.771-1.088-.735-1.113-.731-1.116-.693-1.14a75.161,75.161,0,0,1-8.377-19.613A76.623,76.623,0,0,1,3716.6,770.8a77.323,77.323,0,0,1,.422-21.373,76.193,76.193,0,0,1,2.442-10.43,75.2,75.2,0,0,1,9.146-19.267c.5-.734,1-1.472,1.514-2.2l1.591-2.14,1.663-2.083q.864-1.014,1.739-2.017a77.107,77.107,0,0,1,7.606-7.413A71.953,71.953,0,0,1,3760.615,692.777Z"
                            transform="translate(-3716.06 -692.777)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_308"
                        data-name="Group 308"
                        transform="translate(63.887 97.328)"
                      >
                        <g id="Group_307" data-name="Group 307">
                          <path
                            id="Path_156"
                            data-name="Path 156"
                            d="M3964.771,1018.915a21.341,21.341,0,1,0,21.237,16.141,1.642,1.642,0,1,0-3.164.8,18.079,18.079,0,1,1-6.891-10.208,1.642,1.642,0,1,0,2.2-2.434,1.613,1.613,0,0,0-.271-.2,21.337,21.337,0,0,0-13.115-4.1Zm24.554,1.06a1.64,1.64,0,0,0-1.111.53c-5.821,6.09-15.234,16.455-21.356,22.913l-8.1-7.147a1.647,1.647,0,0,0-2.188,2.462l9.3,8.208a1.642,1.642,0,0,0,2.274-.086c6.116-6.4,16.391-17.752,22.434-24.075a1.642,1.642,0,0,0-1.249-2.8Z"
                            transform="translate(-3943.983 -1018.908)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
                <div
                  v-if="user.badges_filtered['Volunteering']"
                  class="text-center px-8 py-4"
                >
                  <div class="text-blue-darker text-2xl">
                    Volunteer Hours
                  </div>
                  <div class="text-gray text-base mb-4">
                    {{ user.badges_filtered['Volunteering'].value }} Hours
                  </div>
                  <div class="relative text-center">
                    <span
                      class="inline-block absolute text-white text-7xl text-center left-0 right-0 mx-auto mt-5"
                      >{{ user.badges_filtered['Volunteering'].value }}</span
                    >
                    <svg
                      id="Component_2_1"
                      data-name="Component 2 – 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="171.96"
                      height="171.96"
                      viewBox="0 0 171.96 171.96"
                    >
                      <g id="Group_295" data-name="Group 295">
                        <ellipse
                          id="Ellipse_86"
                          data-name="Ellipse 86"
                          cx="85.98"
                          cy="85.98"
                          rx="85.98"
                          ry="85.98"
                          fill="#d12567"
                        />
                      </g>
                      <g
                        id="Group_302"
                        data-name="Group 302"
                        transform="translate(8.499 17.374)"
                      >
                        <g
                          id="Group_300"
                          data-name="Group 300"
                          transform="translate(110.552)"
                        >
                          <path
                            id="Path_151"
                            data-name="Path 151"
                            d="M5121,692.777a71.95,71.95,0,0,1,17.887,11.1,76.941,76.941,0,0,1,7.606,7.413q.877,1,1.74,2.017l1.662,2.083,1.592,2.14c.513.726,1.009,1.464,1.513,2.2a75.2,75.2,0,0,1,9.146,19.267,76.121,76.121,0,0,1,2.442,10.43,77.323,77.323,0,0,1,.422,21.373,76.623,76.623,0,0,1-2.028,10.518,75.144,75.144,0,0,1-8.377,19.613l-.693,1.14-.731,1.116-.735,1.113-.771,1.088-.773,1.085-.806,1.061c-.271.352-.532.711-.812,1.055l-.846,1.029a77.336,77.336,0,0,1-7.308,7.707,72.01,72.01,0,0,1-17.435,11.8,81.144,81.144,0,0,0,28.579-29.552,77.535,77.535,0,0,0,7.557-19.068,78,78,0,0,0-.793-40.568,77.594,77.594,0,0,0-8.3-18.758A80.992,80.992,0,0,0,5121,692.777Z"
                            transform="translate(-5121 -692.777)"
                            fill="#fff"
                          />
                        </g>
                        <g id="Group_301" data-name="Group 301">
                          <path
                            id="Path_152"
                            data-name="Path 152"
                            d="M4714.614,692.777a81,81,0,0,0-29.731,28.4,77.594,77.594,0,0,0-8.3,18.758,78.052,78.052,0,0,0-.793,40.568,77.571,77.571,0,0,0,7.556,19.068,81.15,81.15,0,0,0,28.58,29.552,72.015,72.015,0,0,1-17.436-11.8,77.331,77.331,0,0,1-7.308-7.707l-.846-1.029c-.281-.344-.542-.7-.812-1.055l-.806-1.061-.772-1.085-.771-1.088-.735-1.113-.731-1.116-.693-1.14a75.16,75.16,0,0,1-8.377-19.613,76.476,76.476,0,0,1-2.027-10.518,77.323,77.323,0,0,1,.422-21.373,76.118,76.118,0,0,1,2.441-10.43,75.25,75.25,0,0,1,9.146-19.267c.5-.734,1-1.472,1.513-2.2l1.592-2.14,1.662-2.083q.864-1.014,1.739-2.017a77.053,77.053,0,0,1,7.606-7.413A71.956,71.956,0,0,1,4714.614,692.777Z"
                            transform="translate(-4670.061 -692.777)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_306"
                        data-name="Group 306"
                        transform="translate(55.76 89.506)"
                      >
                        <path
                          id="Path_155"
                          data-name="Path 155"
                          d="M4910.893,1002.427a4.859,4.859,0,0,0-4.838-4.763,4.8,4.8,0,0,0-2.116.5v-.817a5.334,5.334,0,0,0-7.961-4.661v-.238a5.444,5.444,0,0,0-10.888,0v.157a5.138,5.138,0,0,0-7.56,4.532v20.849a.673.673,0,0,1-1.149.469l-1.98-2.191a10.209,10.209,0,0,0-8.24-3.341,3.559,3.559,0,0,0-2.926,5.185l9.907,19.148a19.987,19.987,0,0,0,13.256,10.064,19.625,19.625,0,0,0,4.328.483,18.018,18.018,0,0,0,10.921-3.6c5.389-4.083,9.132-10.833,9.315-16.794C4911.192,1020.126,4910.968,1006.809,4910.893,1002.427Zm-2.633,24.9c-.157,5.178-3.491,11.092-8.254,14.7a15.725,15.725,0,0,1-13.01,2.627,17.237,17.237,0,0,1-11.438-8.662l-9.942-19.169a.837.837,0,0,1,.681-1.218,7.483,7.483,0,0,1,6.049,2.45l1.98,2.191a3.4,3.4,0,0,0,5.886-2.266V997.16a2.419,2.419,0,0,1,4.838,0v16a1.361,1.361,0,1,0,2.722,0V992.472a2.722,2.722,0,0,1,5.444,0v19.373a1.361,1.361,0,1,0,2.722,0V997.358a2.62,2.62,0,1,1,5.239,0v18.263a1.361,1.361,0,1,0,2.722,0v-13.105a2.137,2.137,0,1,1,4.273-.041C4908.246,1006.836,4908.47,1020.105,4908.26,1027.332Z"
                          transform="translate(-4862.836 -987.001)"
                          fill="#fff"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
                <div
                  v-if="user.badges_filtered['Acts of Kindness']"
                  class="text-center px-8 py-4"
                >
                  <div class="text-blue-darker text-2xl">
                    PENCIL Positives
                  </div>
                  <div class="text-gray text-base mb-4">
                    {{ user.badges_filtered['Acts of Kindness'].value }} Acts
                  </div>
                  <div class="relative text-center">
                    <span
                      class="inline-block absolute text-white text-7xl text-center left-0 right-0 mx-auto mt-5"
                      >{{
                        user.badges_filtered['Acts of Kindness'].value
                      }}</span
                    >
                    <svg
                      id="Component_3_1"
                      data-name="Component 3 – 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="171.96"
                      height="171.96"
                      viewBox="0 0 171.96 171.96"
                    >
                      <g id="Group_297" data-name="Group 297">
                        <ellipse
                          id="Ellipse_87"
                          data-name="Ellipse 87"
                          cx="85.98"
                          cy="85.98"
                          rx="85.98"
                          ry="85.98"
                          fill="#37ae8c"
                        />
                      </g>
                      <g
                        id="Group_298"
                        data-name="Group 298"
                        transform="translate(58.469 86.79)"
                      >
                        <path
                          id="Path_148"
                          data-name="Path 148"
                          d="M5878.591,1008.168a1.113,1.113,0,0,0-.2-.244v0a14.25,14.25,0,0,0-15.813-2.335,14.547,14.547,0,0,0-7.39,11.058v.061a21.851,21.851,0,0,0-1.708,2.108l.025-16.724a67.291,67.291,0,0,0,7.11-5c5.028-4.324,7.58-8.384,7.58-12.066a9.106,9.106,0,0,0-9.01-9.1,8.994,8.994,0,0,0-3.939.976,9.3,9.3,0,0,0-2.866,2.145,9.006,9.006,0,0,0-15.821,5.98,14.084,14.084,0,0,0,4.536,9.157l1.549,1.557c.488.451.977.905,1.5,1.347a65.78,65.78,0,0,0,7.113,5l-.037,25.154a21.731,21.731,0,0,0-1.762-2.235v-.075a14.541,14.541,0,0,0-7.384-11.056,14.254,14.254,0,0,0-15.813,2.335,1.121,1.121,0,0,0,.164,1.788c1.637,1.01,3.252,2.113,4.8,3.279,1.739,1.313,3,2.408,4.006,3.289a11.807,11.807,0,0,0,5.02,3.155,8.579,8.579,0,0,0,2.122.261,12.571,12.571,0,0,0,5.477-1.42,17.515,17.515,0,0,1,3.377,5.478v2.33a1.121,1.121,0,1,0,2.242,0v-2.089a1.114,1.114,0,0,0,0-.62v-8.052a15.782,15.782,0,0,1,3.32-5.329,12.576,12.576,0,0,0,5.488,1.425,8.586,8.586,0,0,0,2.122-.261,11.787,11.787,0,0,0,5.031-3.17c1.011-.881,2.268-1.976,4.007-3.289,1.547-1.169,3.172-2.272,4.8-3.279A1.123,1.123,0,0,0,5878.591,1008.168Zm-41.12,12.317a18.989,18.989,0,0,1,8.682,4.392,8.384,8.384,0,0,1-5.36.673,9.967,9.967,0,0,1-4.093-2.672c-1.037-.9-2.324-2.028-4.128-3.389-1.179-.89-2.4-1.745-3.634-2.55a11.913,11.913,0,0,1,12.125-1.059,11.284,11.284,0,0,1,5.466,6.386,21.319,21.319,0,0,0-8.589-3.978,1.123,1.123,0,1,0-.469,2.2Zm14.911-20.34a64,64,0,0,1-6.773-4.761c-.488-.429-.964-.849-1.394-1.252l-.007,0-1.5-1.505a11.984,11.984,0,0,1-3.9-7.606,6.766,6.766,0,0,1,12.605-3.506,1.123,1.123,0,0,0,1.933,0q.1-.165.2-.322a7.255,7.255,0,0,1,5.6-3.023h.027a6.857,6.857,0,0,1,6.781,6.854c0,3-2.289,6.486-6.8,10.363A65.339,65.339,0,0,1,5852.382,1000.145Zm19.7,11.056-.012.01c-1.8,1.361-3.092,2.486-4.13,3.389a9.948,9.948,0,0,1-4.094,2.672,8.39,8.39,0,0,1-5.368-.678,18.994,18.994,0,0,1,8.682-4.392,1.123,1.123,0,1,0-.468-2.2,21.312,21.312,0,0,0-8.59,3.977,11.288,11.288,0,0,1,5.466-6.383,11.911,11.911,0,0,1,12.125,1.059C5874.472,1009.456,5873.254,1010.31,5872.08,1011.2Z"
                          transform="translate(-5825.884 -975.923)"
                          fill="#fff"
                        />
                      </g>
                      <g
                        id="Group_305"
                        data-name="Group 305"
                        transform="translate(8.99 17.374)"
                      >
                        <g
                          id="Group_303"
                          data-name="Group 303"
                          transform="translate(110.552)"
                        >
                          <path
                            id="Path_153"
                            data-name="Path 153"
                            d="M6075,692.777a71.953,71.953,0,0,1,17.888,11.1,76.941,76.941,0,0,1,7.606,7.413q.877,1,1.74,2.017l1.662,2.083,1.592,2.14c.513.726,1.009,1.464,1.513,2.2a75.217,75.217,0,0,1,9.146,19.267,76.048,76.048,0,0,1,2.442,10.43,77.3,77.3,0,0,1,.422,21.373,76.552,76.552,0,0,1-2.028,10.518,75.143,75.143,0,0,1-8.377,19.613l-.693,1.14-.731,1.116-.735,1.113-.771,1.088-.773,1.085-.806,1.061c-.271.352-.532.711-.812,1.055l-.846,1.029a77.448,77.448,0,0,1-7.308,7.707,72.01,72.01,0,0,1-17.435,11.8,81.144,81.144,0,0,0,28.579-29.552,77.535,77.535,0,0,0,7.557-19.068,77.986,77.986,0,0,0-.794-40.568,77.574,77.574,0,0,0-8.3-18.758A81,81,0,0,0,6075,692.777Z"
                            transform="translate(-6075 -692.777)"
                            fill="#fff"
                          />
                        </g>
                        <g id="Group_304" data-name="Group 304">
                          <path
                            id="Path_154"
                            data-name="Path 154"
                            d="M5668.615,692.777a81,81,0,0,0-29.731,28.4,77.575,77.575,0,0,0-8.3,18.758,78.043,78.043,0,0,0-.794,40.568,77.591,77.591,0,0,0,7.556,19.068,81.15,81.15,0,0,0,28.58,29.552,72.022,72.022,0,0,1-17.435-11.8,77.336,77.336,0,0,1-7.308-7.707l-.845-1.029c-.281-.344-.542-.7-.812-1.055l-.806-1.061-.773-1.085-.771-1.088-.735-1.113-.731-1.116-.693-1.14a75.16,75.16,0,0,1-8.377-19.613,76.477,76.477,0,0,1-2.028-10.518,77.348,77.348,0,0,1,.421-21.373,76.265,76.265,0,0,1,2.442-10.43,75.233,75.233,0,0,1,9.146-19.267c.5-.734,1-1.472,1.513-2.2l1.591-2.14,1.663-2.083q.864-1.014,1.739-2.017a77.107,77.107,0,0,1,7.606-7.413A71.95,71.95,0,0,1,5668.615,692.777Z"
                            transform="translate(-5624.061 -692.777)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
                <div
                  v-if="user.badges_filtered['Donations']"
                  class="text-center px-8 py-4"
                >
                  <div class="text-blue-darker text-2xl">
                    Donation
                  </div>
                  <div class="text-gray text-base mb-4">
                    {{ user.badges_filtered['Donations'].value }} Donations
                  </div>
                  <div class="relative text-center">
                    <span
                      class="inline-block absolute text-white text-7xl text-center left-0 right-0 mx-auto mt-5"
                      >{{ user.badges_filtered['Donations'].value }}</span
                    >
                    <svg
                      id="Component_4_1"
                      data-name="Component 4 – 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="171.96"
                      height="171.96"
                      viewBox="0 0 171.96 171.96"
                    >
                      <g id="Group_310" data-name="Group 310">
                        <ellipse
                          id="Ellipse_88"
                          data-name="Ellipse 88"
                          cx="85.98"
                          cy="85.98"
                          rx="85.98"
                          ry="85.98"
                          fill="#f68247"
                        />
                      </g>
                      <g
                        id="Group_318"
                        data-name="Group 318"
                        transform="translate(8.009 17.864)"
                      >
                        <g
                          id="Group_316"
                          data-name="Group 316"
                          transform="translate(110.552)"
                        >
                          <path
                            id="Path_166"
                            data-name="Path 166"
                            d="M4167,1779.777a71.952,71.952,0,0,1,17.887,11.1,77.067,77.067,0,0,1,7.607,7.414q.876,1,1.739,2.017l1.662,2.083,1.592,2.14c.513.726,1.01,1.464,1.513,2.2a75.179,75.179,0,0,1,9.146,19.267,76.129,76.129,0,0,1,2.442,10.43,77.323,77.323,0,0,1,.422,21.373,76.7,76.7,0,0,1-2.027,10.518,75.165,75.165,0,0,1-8.378,19.613l-.693,1.14-.731,1.116-.735,1.113-.771,1.088-.773,1.085-.806,1.061c-.271.352-.532.711-.812,1.055l-.846,1.029a77.331,77.331,0,0,1-7.308,7.707,72.009,72.009,0,0,1-17.434,11.8,81.153,81.153,0,0,0,28.579-29.552,77.554,77.554,0,0,0,7.556-19.068,78,78,0,0,0-.793-40.568,77.574,77.574,0,0,0-8.3-18.758A81,81,0,0,0,4167,1779.777Z"
                            transform="translate(-4167 -1779.777)"
                            fill="#fff"
                          />
                        </g>
                        <g id="Group_317" data-name="Group 317">
                          <path
                            id="Path_167"
                            data-name="Path 167"
                            d="M3760.615,1779.777a81,81,0,0,0-29.732,28.4,77.573,77.573,0,0,0-8.3,18.758,78.062,78.062,0,0,0-.794,40.568,77.575,77.575,0,0,0,7.557,19.068,81.149,81.149,0,0,0,28.579,29.552,72.021,72.021,0,0,1-17.435-11.8,77.392,77.392,0,0,1-7.309-7.707l-.845-1.029c-.281-.344-.542-.7-.812-1.055l-.806-1.061-.773-1.085-.771-1.088-.735-1.113-.731-1.116-.693-1.14a75.164,75.164,0,0,1-8.377-19.613,76.628,76.628,0,0,1-2.028-10.518,77.323,77.323,0,0,1,.422-21.373,76.2,76.2,0,0,1,2.442-10.43,75.2,75.2,0,0,1,9.146-19.267c.5-.734,1-1.472,1.514-2.2l1.591-2.14,1.663-2.083q.864-1.014,1.739-2.017a77.116,77.116,0,0,1,7.606-7.414A71.963,71.963,0,0,1,3760.615,1779.777Z"
                            transform="translate(-3716.06 -1779.777)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_329"
                        data-name="Group 329"
                        transform="translate(47.22 92.524)"
                      >
                        <g id="Group_325" data-name="Group 325">
                          <path
                            id="Path_172"
                            data-name="Path 172"
                            d="M3953.058,2084.478a.929.929,0,0,0-.887-.1L3925.038,2095a12.686,12.686,0,0,0-20.749-.063l-26.99-10.549a.985.985,0,0,0-.887.1.968.968,0,0,0-.412.792v34.007a.94.94,0,0,0,.412.776.951.951,0,0,0,.539.174.825.825,0,0,0,.333-.063l27.307-10.153a12.664,12.664,0,0,0,20.147-.063l27.449,10.216a.829.829,0,0,0,.333.063.949.949,0,0,0,.538-.174.963.963,0,0,0,.412-.776V2085.27A.892.892,0,0,0,3953.058,2084.478Zm-49.545,23.9-25.612,9.52v-31.251l25.39,9.931a13.243,13.243,0,0,0-.934,2.5v.032c-.1.38-.175.776-.238,1.172,0,.032-.016.048-.016.079-.032.19-.048.364-.063.554a.266.266,0,0,1-.016.111c-.016.19-.032.364-.047.554v.095c-.016.19-.016.4-.016.6h0c0,.19,0,.4.016.586v.127c.016.19.032.364.047.554,0,.032.016.079.016.111.016.158.032.333.063.491,0,.032.016.063.016.1.032.19.063.364.1.539,0,.032.016.079.016.111a10.163,10.163,0,0,0,.3,1.141c0,.015,0,.015.016.032A12.773,12.773,0,0,0,3903.513,2108.379Zm11.135,4.688a10.834,10.834,0,0,1-10.311-7.587v-.015c-.048-.158-.1-.317-.127-.476,0-.016-.016-.031-.016-.047a4.5,4.5,0,0,1-.111-.491c0-.016-.016-.048-.016-.063-.032-.142-.047-.269-.079-.412,0-.048-.016-.079-.016-.126-.016-.159-.047-.317-.063-.476v-.047a3.947,3.947,0,0,1-.031-.443v-.127c0-.158-.016-.333-.016-.491h0c0-.158,0-.333.016-.491v-.127c.016-.142.016-.3.031-.443v-.048c.016-.158.032-.317.063-.475,0-.031.016-.079.016-.111a4.253,4.253,0,0,1,.079-.443v-.048c.032-.174.079-.333.111-.507v-.016a10.794,10.794,0,1,1,10.47,13.511Zm36.937,4.831-25.611-9.535a12.692,12.692,0,0,0,.221-11.8l25.39-9.931V2117.9Z"
                            transform="translate(-3876 -2084.311)"
                            fill="#fff"
                          />
                        </g>
                        <g
                          id="Group_326"
                          data-name="Group 326"
                          transform="translate(5.682 8.051)"
                        >
                          <path
                            id="Path_173"
                            data-name="Path 173"
                            d="M3911.442,2120.147l-11.071-2.962a.943.943,0,1,0-.491,1.822l11.072,2.962a1.226,1.226,0,0,0,.253.032.965.965,0,0,0,.918-.7A.95.95,0,0,0,3911.442,2120.147Z"
                            transform="translate(-3899.179 -2117.149)"
                            fill="#fff"
                          />
                        </g>
                        <g
                          id="Group_327"
                          data-name="Group 327"
                          transform="translate(20.577 27.333)"
                        >
                          <path
                            id="Path_174"
                            data-name="Path 174"
                            d="M3972.224,2198.745a.965.965,0,0,0-1.2.6l-4.784,14.667-.364-1.109a.892.892,0,0,0-.522-.57.947.947,0,0,0-.776.016l-2.106,1,5.322-16.3a.952.952,0,0,0-1.806-.6l-6,18.405a.969.969,0,0,0,.269,1.014.947.947,0,0,0,1.03.143l3.136-1.489.935,2.851a.936.936,0,0,0,.9.649.957.957,0,0,0,.9-.649l5.686-17.423A.953.953,0,0,0,3972.224,2198.745Z"
                            transform="translate(-3959.935 -2195.801)"
                            fill="#fff"
                          />
                        </g>
                        <g
                          id="Group_328"
                          data-name="Group 328"
                          transform="translate(43.204 27.072)"
                        >
                          <path
                            id="Path_175"
                            data-name="Path 175"
                            d="M4059.139,2195.392a.952.952,0,1,0-1.806.6l5.322,16.3-2.106-1a.95.95,0,0,0-.776-.016.93.93,0,0,0-.523.57l-.364,1.109-4.8-14.651a.945.945,0,0,0-1.2-.6.933.933,0,0,0-.6,1.2l5.7,17.423a.936.936,0,0,0,.9.649.956.956,0,0,0,.9-.649l.935-2.851,3.12,1.489a.943.943,0,0,0,1.3-1.156Z"
                            transform="translate(-4052.228 -2194.737)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
                <div
                  v-if="user.badges_filtered['Streaks']"
                  class="text-center px-8 py-4"
                >
                  <div class="text-blue-darker text-2xl">
                    Streaks
                  </div>
                  <div class="text-gray text-base mb-4">
                    {{ user.badges_filtered['Streaks'].value }} Days
                  </div>
                  <div class="relative text-center">
                    <span
                      class="inline-block absolute text-white text-7xl text-center left-0 right-0 mx-auto mt-5"
                      >{{ user.badges_filtered['Streaks'].value }}</span
                    >
                    <svg
                      id="Component_6_1"
                      data-name="Component 6 – 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="171.96"
                      height="171.96"
                      viewBox="0 0 171.96 171.96"
                    >
                      <g id="Group_314" data-name="Group 314">
                        <ellipse
                          id="Ellipse_90"
                          data-name="Ellipse 90"
                          cx="85.98"
                          cy="85.98"
                          rx="85.98"
                          ry="85.98"
                          fill="#2968b1"
                        />
                      </g>
                      <g
                        id="Group_324"
                        data-name="Group 324"
                        transform="translate(8.99 17.864)"
                      >
                        <g
                          id="Group_322"
                          data-name="Group 322"
                          transform="translate(110.552)"
                        >
                          <path
                            id="Path_170"
                            data-name="Path 170"
                            d="M6075,1779.777a71.963,71.963,0,0,1,17.888,11.1,76.95,76.95,0,0,1,7.606,7.414q.877,1,1.74,2.017l1.662,2.083,1.592,2.14c.513.726,1.009,1.464,1.513,2.2a75.211,75.211,0,0,1,9.146,19.267,76.055,76.055,0,0,1,2.442,10.43,77.3,77.3,0,0,1,.422,21.373,76.556,76.556,0,0,1-2.028,10.518,75.146,75.146,0,0,1-8.377,19.613l-.693,1.14-.731,1.116-.735,1.113-.771,1.088-.773,1.085-.806,1.061c-.271.352-.532.711-.812,1.055l-.846,1.029a77.443,77.443,0,0,1-7.308,7.707,72.012,72.012,0,0,1-17.435,11.8,81.145,81.145,0,0,0,28.579-29.552,77.536,77.536,0,0,0,7.557-19.068,77.987,77.987,0,0,0-.794-40.568,77.573,77.573,0,0,0-8.3-18.758A81,81,0,0,0,6075,1779.777Z"
                            transform="translate(-6075 -1779.777)"
                            fill="#fff"
                          />
                        </g>
                        <g id="Group_323" data-name="Group 323">
                          <path
                            id="Path_171"
                            data-name="Path 171"
                            d="M5668.615,1779.777a81,81,0,0,0-29.731,28.4,77.574,77.574,0,0,0-8.3,18.758,78.043,78.043,0,0,0-.794,40.568,77.593,77.593,0,0,0,7.556,19.068,81.152,81.152,0,0,0,28.58,29.552,72.024,72.024,0,0,1-17.435-11.8,77.331,77.331,0,0,1-7.308-7.707l-.845-1.029c-.281-.344-.542-.7-.812-1.055l-.806-1.061-.773-1.085-.771-1.088-.735-1.113-.731-1.116-.693-1.14a75.162,75.162,0,0,1-8.377-19.613,76.482,76.482,0,0,1-2.028-10.518,77.348,77.348,0,0,1,.421-21.373,76.272,76.272,0,0,1,2.442-10.43,75.227,75.227,0,0,1,9.146-19.267c.5-.734,1-1.472,1.513-2.2l1.591-2.14,1.663-2.083q.864-1.014,1.739-2.017a77.116,77.116,0,0,1,7.606-7.414A71.961,71.961,0,0,1,5668.615,1779.777Z"
                            transform="translate(-5624.061 -1779.777)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_332"
                        data-name="Group 332"
                        transform="translate(65.565 91.222)"
                      >
                        <g id="Group_330" data-name="Group 330">
                          <path
                            id="Path_178"
                            data-name="Path 178"
                            d="M5873.385,2084.431c4.009,3.75,5.884,8.6,5.949,15.325a3.628,3.628,0,0,0,3.039,3.621,1.79,1.79,0,0,0,.582.065,3.6,3.6,0,0,0,3.621-3.556v-.517c0-.259,0-.841.064-1.487a.647.647,0,0,1,1.1-.453,20.243,20.243,0,0,1,5.431,13.514,16.818,16.818,0,0,1-5.431,11.833,18.212,18.212,0,0,1-12.479,5.238,18.508,18.508,0,0,1-12.48-5.238,16.818,16.818,0,0,1-5.431-11.833c0-6.66,4.073-11.315,7.63-15.324,4.073-4.591,6.207-8.341,6.6-11.381a.62.62,0,0,1,1.034-.388ZM5869.44,2079a1.269,1.269,0,0,0-1.1.582c-.259.453.129,1.423.582,2.651.9,2.781-1.876,7.242-5.82,11.7-3.685,4.2-8.276,9.376-8.276,17.07,0,10.346,9.765,19.722,20.5,19.722s20.5-9.376,20.5-19.722a22.944,22.944,0,0,0-8.276-17.329l-.646-.517a1.585,1.585,0,0,0-1.035-.388,1.551,1.551,0,0,0-1.423.905,51.625,51.625,0,0,0-.388,5.755v.453a1.021,1.021,0,0,1-1.034,1.034h-.194a1.113,1.113,0,0,1-.9-1.1c-.065-7.759-2.393-13.191-6.79-17.264-2-1.875-4.268-3.557-5.69-3.557Z"
                            transform="translate(-5854.827 -2079)"
                            fill="#fff"
                          />
                        </g>
                        <g
                          id="Group_331"
                          data-name="Group 331"
                          transform="translate(11.962 27.351)"
                        >
                          <path
                            id="Path_179"
                            data-name="Path 179"
                            d="M5912.156,2193.541l4.074,4.849.065.065.064.065a5.818,5.818,0,0,1,1.681,4.138,5.884,5.884,0,1,1-11.769,0,5.818,5.818,0,0,1,1.682-4.138l.064-.065.065-.065,4.073-4.849m0-2.975a1.833,1.833,0,0,0-1.422.647l-4.656,5.56a8.466,8.466,0,1,0,14.484,5.949,8.3,8.3,0,0,0-2.457-5.949l-4.655-5.56a1.438,1.438,0,0,0-1.294-.647Z"
                            transform="translate(-5903.622 -2190.566)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
                <div
                  v-for="(badge, index) in user.badges_filtered['Others']"
                  :key="index"
                  class="text-center px-8 py-4"
                >
                  <div class="text-blue-darker text-2xl">
                    Connection
                  </div>
                  <div class="text-gray text-base mb-4 real-capitalize">
                    {{ badge.name }}
                  </div>
                  <div class="relative text-center">
                    <span
                      class="inline-block absolute text-white text-7xl text-center left-0 right-0 mx-auto mt-5"
                    ></span>
                    <svg
                      id="Component_5_1"
                      data-name="Component 5 – 1"
                      xmlns="http://www.w3.org/2000/svg"
                      width="171.96"
                      height="171.96"
                      viewBox="0 0 171.96 171.96"
                    >
                      <g id="Group_312" data-name="Group 312">
                        <ellipse
                          id="Ellipse_89"
                          data-name="Ellipse 89"
                          cx="85.98"
                          cy="85.98"
                          rx="85.98"
                          ry="85.98"
                          fill="#c8362a"
                        />
                      </g>
                      <g
                        id="Group_321"
                        data-name="Group 321"
                        transform="translate(8.499 17.864)"
                      >
                        <g
                          id="Group_319"
                          data-name="Group 319"
                          transform="translate(110.552)"
                        >
                          <path
                            id="Path_168"
                            data-name="Path 168"
                            d="M5121,1779.777a71.961,71.961,0,0,1,17.887,11.1,76.95,76.95,0,0,1,7.606,7.414q.877,1,1.74,2.017l1.662,2.083,1.592,2.14c.513.726,1.009,1.464,1.513,2.2a75.2,75.2,0,0,1,9.146,19.267,76.129,76.129,0,0,1,2.442,10.43,77.323,77.323,0,0,1,.422,21.373,76.628,76.628,0,0,1-2.028,10.518,75.147,75.147,0,0,1-8.377,19.613l-.693,1.14-.731,1.116-.735,1.113-.771,1.088-.773,1.085-.806,1.061c-.271.352-.532.711-.812,1.055l-.846,1.029a77.331,77.331,0,0,1-7.308,7.707,72.012,72.012,0,0,1-17.435,11.8,81.145,81.145,0,0,0,28.579-29.552,77.536,77.536,0,0,0,7.557-19.068,78,78,0,0,0-.793-40.568,77.593,77.593,0,0,0-8.3-18.758A81,81,0,0,0,5121,1779.777Z"
                            transform="translate(-5121 -1779.777)"
                            fill="#fff"
                          />
                        </g>
                        <g id="Group_320" data-name="Group 320">
                          <path
                            id="Path_169"
                            data-name="Path 169"
                            d="M4714.614,1779.777a81,81,0,0,0-29.731,28.4,77.593,77.593,0,0,0-8.3,18.758,78.053,78.053,0,0,0-.793,40.568,77.572,77.572,0,0,0,7.556,19.068,81.152,81.152,0,0,0,28.58,29.552,72.017,72.017,0,0,1-17.436-11.8,77.326,77.326,0,0,1-7.308-7.707l-.846-1.029c-.281-.344-.542-.7-.812-1.055l-.806-1.061-.772-1.085-.771-1.088-.735-1.113-.731-1.116-.693-1.14a75.162,75.162,0,0,1-8.377-19.613,76.48,76.48,0,0,1-2.027-10.518,77.323,77.323,0,0,1,.422-21.373,76.125,76.125,0,0,1,2.441-10.43,75.245,75.245,0,0,1,9.146-19.267c.5-.734,1-1.472,1.513-2.2l1.592-2.14,1.662-2.083q.864-1.014,1.739-2.017a77.062,77.062,0,0,1,7.606-7.414A71.967,71.967,0,0,1,4714.614,1779.777Z"
                            transform="translate(-4670.061 -1779.777)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                      <g
                        id="Group_66"
                        data-name="Group 66"
                        transform="translate(61.372 91.222)"
                      >
                        <g
                          id="Path_53"
                          data-name="Path 53"
                          transform="translate(17.518)"
                        >
                          <path
                            id="Path_176"
                            data-name="Path 176"
                            d="M4990.876,2083.074a13.954,13.954,0,0,0-19.707,0l-8.882,9.074a21.821,21.821,0,0,1,3.814.7l7.328-7.521a10.745,10.745,0,0,1,15.2,15.193l-9.693,9.695a10.664,10.664,0,0,1-7.608,3.144c-2.874,0-8.1-4.031-10.127-6.061a10.69,10.69,0,0,1-1.62-2.068,2.736,2.736,0,0,0-.771.544l-1.627,1.628a45.488,45.488,0,0,0,4.485,4.684c7.085,5.4,14.077,5.822,19.514.388l9.695-9.7a13.933,13.933,0,0,0,.023-19.716S4990.9,2083.06,4990.876,2083.074Z"
                            transform="translate(-4957.182 -2079)"
                            fill="#fff"
                          />
                        </g>
                        <g
                          id="Path_54"
                          data-name="Path 54"
                          transform="translate(0 17.716)"
                        >
                          <path
                            id="Path_177"
                            data-name="Path 177"
                            d="M4907.255,2182.49a10.745,10.745,0,1,1-15.194-15.2l9.695-9.695a10.753,10.753,0,0,1,15.2,0c.63.63,4.087,4.045,4.539,4.8a2.776,2.776,0,0,0,.777-.548l1.624-1.626a21.073,21.073,0,0,0-1.769-2.158c-4.308-4.909-9.034-6.8-12.767-6.8a13.853,13.853,0,0,0-9.853,4.081l-9.695,9.7a13.935,13.935,0,1,0,19.7,19.711l9.476-9.281a21.747,21.747,0,0,1-3.792-.723Z"
                            transform="translate(-4885.725 -2151.262)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Tab>
        <Tab
          title='<svg id="Group_263" data-name="Group 263" xmlns="http://www.w3.org/2000/svg" width="41.324" height="29.621" viewBox="0 0 41.324 29.621" class="inline-block align-middle mr-2"><path id="Path_123" data-name="Path 123" d="M50.145,19.3H48.7v4.816h.578a5.235,5.235,0,0,1,.867.048Z" transform="translate(-28.664 -19.3)" fill="#00638a"/><path id="Path_124" data-name="Path 124" d="M11.579,38.52,8.16,35.1c-.337.337-.722.674-1.06,1.011l3.42,3.42C10.857,39.194,11.194,38.857,11.579,38.52Z" transform="translate(-7.1 -27.49)" fill="#00638a"/><path id="Path_125" data-name="Path 125" d="M27.249,23.1c-.433.193-.915.337-1.349.53l1.83,4.479a11.217,11.217,0,0,1,1.349-.53Z" transform="translate(-16.845 -21.27)" fill="#00638a"/><path id="Path_126" data-name="Path 126" d="M83.7,38.92l1.011,1.011,3.42-3.42L87.12,35.5Z" transform="translate(-46.807 -27.698)" fill="#00638a"/><path id="Path_127" data-name="Path 127" d="M69.53,23.3,67.7,27.779c.433.193.915.337,1.349.578l1.83-4.479C70.445,23.685,69.964,23.493,69.53,23.3Z" transform="translate(-38.513 -21.373)" fill="#00638a"/><path id="Path_128" data-name="Path 128" d="M48.549,45.352l.193-.385-.193-.385a21.78,21.78,0,0,0-37.857.048l-.193.385.193.385a21.828,21.828,0,0,0,37.857-.048Zm-36.412-.385a20.626,20.626,0,0,1,13.149-9.392,10.336,10.336,0,0,0,0,18.784A20.293,20.293,0,0,1,12.138,44.967Zm8.573,0a8.91,8.91,0,1,1,8.91,8.91A8.921,8.921,0,0,1,20.711,44.967Zm13.245,9.44a10.336,10.336,0,0,0,0-18.784A20.747,20.747,0,0,1,47.1,45.015,20.87,20.87,0,0,1,33.956,54.407Z" transform="translate(-8.862 -26.713)" fill="#00638a"/></svg><span class="align-middle">Interests</span>'
        >
          <div class="h-auto flex mt-16 pl-15 pr-15 justify-center">
            <div
              class="left-posts w-8/12 bg-white rounded-xl shadow-box relative px-12 py-12 mb-6"
            >
              <div class="text-blue-darker text-base mb-2 ml-4">
                Organizations:
              </div>
              <div class="flex justify-start mb-6 flex-wrap">
                <div
                  v-for="org in user.charity_organizations"
                  :key="org.id"
                  class="bg-gray-lightest text-blue-darker rounded-comments leading-tight w-50 h-16 py-6 px-6 mx-4 mb-7.5 truncate"
                  ><router-link
                    :to="{
                      name: 'organization',
                      params: { organizationId: org.id },
                    }"
                  >
                    <img
                      v-if="org.image_url !== ''"
                      :src="org.image_url"
                      class="rounded-full w-5 h-5 inline-block align-middle"
                    />
                    {{ org.name }}
                  </router-link>
                </div>
                <div
                  v-if="user.charity_organizations.length === 0"
                  class="ml-4"
                >
                  Search for an organizations or choose any you see in the posts
                  feed to follow
                </div>
              </div>
              <div class="text-blue-darker text-base mb-2 ml-4">
                Causes:
              </div>
              <div class="flex justify-start mb-6 flex-wrap">
                <div
                  v-for="cause in user.causes"
                  :key="cause.id"
                  class="bg-gray-lightest text-blue-darker rounded-comments leading-tight w-50 h-16 py-6 px-6 mx-4 mb-7.5 truncate"
                  ><router-link
                    :to="{
                      name: 'cause',
                      params: { causeId: cause.id },
                    }"
                  >
                    {{ cause.name }}
                  </router-link>
                </div>
                <div v-if="user.causes.length === 0" class="ml-4">
                  Search for causes or choose any you see in the posts feed to
                  follow
                </div>
              </div>
              <div class="text-blue-darker text-base mb-2 ml-4">
                Tags:
              </div>
              <div class="flex justify-start mb-6 flex-wrap">
                <div
                  v-for="tag in user.tags"
                  :key="tag.id"
                  class="bg-gray-lightest text-blue-darker rounded-comments leading-tight w-50 h-16 py-6 px-6 mx-4 mb-7.5 truncate"
                  ><router-link
                    :to="{
                      name: 'tag',
                      params: { tagId: tag.id },
                    }"
                  >
                    {{ tag.name }}
                  </router-link>
                </div>
                <div v-if="user.tags.length === 0" class="ml-4">
                  Search for a tag or choose any you see in the posts feed to
                  follow
                </div>
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>
    </div>
  </Layout>
</template>
